import { useState } from 'react';
import { setCookie, getCookie } from 'utils/cookieStore';

function useCookie(key, initialValue) {
  const [item, setInnerValue] = useState(() => getCookie(key) || initialValue);

  const setValue = (value, options) => {
    setInnerValue(value);
    setCookie(key, value, options);
  };

  return [item, setValue];
}

export default useCookie;
